import React from 'react'
import Header from '../components/Header/Header'
import Aboutpage from '../components/Aboutpage/Aboutpage'


function About() {
  return (
    <div id="about">
      <Header />
      <Aboutpage />
    </div>
  )
}

export default About
